import React from 'react'

const EditIconSvg = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 25 24" fill="none">
                <path d="M18.7275 1.99988C18.4715 1.99988 18.2155 2.09785 18.0205 2.29285L16.0205 4.29285L14.6064 5.70691L3.31348 16.9999V20.9999H7.31348L22.0205 6.29285C22.4115 5.90185 22.4115 5.26878 22.0205 4.87878L19.4346 2.29285C19.2396 2.09785 18.9835 1.99988 18.7275 1.99988ZM18.7275 4.41394L19.8994 5.58582L18.6064 6.87878L17.4346 5.70691L18.7275 4.41394ZM16.0205 7.12097L17.1924 8.29285L6.48535 18.9999H5.31348V17.828L16.0205 7.12097Z" fill="#fff" />
            </svg>
        </>
    )
}

export default EditIconSvg